import React, { useEffect, useState } from 'react';
import { listThreads, postMessage } from './api';
import { COPY } from './copy';
import MessageList from './MessageList';
import MessageComposer from './MessageComposer';

// Specialist-side panel on a CLOSED issue when there is an open GP→Specialist
// thread (story #26561). Shown at the top of the report area.
//
// - Renders the GP's prompt under the red "ADDITIONAL INFORMATION REQUESTED" header.
// - One-shot composer: the specialist's first reply auto-closes the thread
//   server-side; after that the section is read-only.
const SpecialistClosedIssueResponseSection = ({ issue }) => {
  const [thread, setThread] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadFailed, setLoadFailed] = useState(false);

  const refresh = async () => {
    try {
      const data = await listThreads(issue.id);
      const gpThread = (data || []).find(
        (t) => t.direction === 'gp_to_specialist'
      );
      setThread(gpThread || null);
      setLoadFailed(false);
    } catch (err) {
      if (err.response?.status === 403 || err.response?.status === 404) {
        setLoadFailed(false);
      } else {
        setLoadFailed(true);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, [issue.id]);

  const handleSubmit = async ({ body, files }) => {
    if (!thread) return;
    const { request_message: newMessage, thread: updatedThread } = await postMessage(
      issue.id,
      thread.id,
      { body, files }
    );
    setThread((prev) => ({
      ...prev,
      messages: [...prev.messages, newMessage],
      state: updatedThread.state,
      last_activity_at: updatedThread.last_activity_at,
    }));
  };

  if (loading || loadFailed) return null;
  if (!thread) return null;

  const lastAuthorRole = thread.messages?.[thread.messages.length - 1]?.author?.role;
  const awaitingSpecialist = thread.state === 'open' && lastAuthorRole === 'gp';

  return (
    <div className="bg-white rounded shadow mb-4">
      <div
        className="font-semibold uppercase text-sm text-white px-3 py-2 rounded-t"
        style={{ backgroundColor: COPY.hex.alertRed }}
      >
        {COPY.sections.additionalInformationRequested}
      </div>
      <div className="border border-t-0 border-gray-200 rounded-b p-3 bg-slate-50">
        <MessageList messages={thread.messages} />
        {awaitingSpecialist && (
          <MessageComposer
            onSubmit={handleSubmit}
            placeholder="Reply to the GP's request"
          />
        )}
      </div>
    </div>
  );
};

export default SpecialistClosedIssueResponseSection;
